import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  standalone: false,
  name: 'momentFormat'
})
export class MomentFormatPipe implements PipeTransform {

  transform(value: any, format: string): unknown {
    return moment(this.toMomentDate(value)).format(format);
  }

  /**
   * Converts a backend date value (array or string) to a moment-parseable value.
   * Backend Joda LocalDateTime serializes as [year, month, day, hour, min, sec, ms]
   * where month is 1-based, but moment arrays expect 0-based months.
   */
  private toMomentDate(value: any): any {
    if (Array.isArray(value)) {
      const [year, month, day, hour = 0, minute = 0, second = 0, ms = 0] = value;
      return new Date(year, month - 1, day, hour, minute, second, ms);
    }
    return value;
  }

}
